import { render } from "./ImageCos.vue?vue&type=template&id=7626bbbb"
import script from "./ImageCos.vue?vue&type=script&lang=js"
export * from "./ImageCos.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__